module.exports = __webpack_public_path__ + "GPP-LF.jpg?45c7d19f26baf75fa3be4f82f28eaa2c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GPP-LF.jpg
// module id = 90
// module chunks = 0